import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  name: 'Camila G.',
  role: '📍 Buenos Aires | Docente de Biología Secundaria',
  quote: 'Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Biología organizado. Nunca pensé que un material iba a ser tan completo. Las rúbricas por actividad son exactamente lo que necesitaba.'
}, {
  initials: 'MG',
  name: 'Martín G.',
  role: '📍 GBA | Docente de Biología Secundaria',
  quote: 'Empecé con el Pack Avanzado y no me arrepiento. El sistema completo era tan claro que las actividades secuenciadas me cambiaron la forma de planificar.'
}, {
  initials: 'LG',
  name: 'Laura G.',
  role: '📍 Córdoba | Profesora de Ciencias Naturales',
  quote: 'Lo que más valoro es que está organizado POR AÑO. No tengo que adivinar qué le corresponde a cada curso. Todo ya está pensado, ordenado y listo.'
}, {
  initials: 'AT',
  name: 'Alejandra T.',
  role: '📍 Santa Fe | Docente de Biología',
  quote: 'Llegué a marzo con todo listo por primera vez en 8 años de docencia. Las guías de laboratorio low cost me salvaron. Mis colegas me preguntaron cómo lo había preparado todo tan bien.'
}, {
  initials: 'RS',
  name: 'Roberto S.',
  role: '📍 Mendoza | Docente Secundaria',
  quote: 'Las rúbricas integradas me cambiaron la corrección. Por fin evalúo con criterios claros y objetivos. Mis alumnos saben exactamente qué se espera de ellos.'
}];
export function FullTestimonials() {
  return <section className="py-20 px-4 bg-white" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-16" data-id="element-145">
          Lo que dicen los docentes de Biología{' '}
          <br className="hidden md:block" data-id="element-146" />
          <span className="text-brand-blue" data-id="element-147">que ya tienen su MegaPack:</span>
        </h2>

        <div className="space-y-8" data-id="element-148">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-gray p-8 rounded-2xl shadow-md border border-gray-200" data-id="element-149">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-150">
                <div className="flex-shrink-0 flex flex-col items-center" data-id="element-151">
                  <div className="w-16 h-16 bg-brand-blue text-white rounded-full flex items-center justify-center text-xl font-bold mb-3" data-id="element-152">
                    {t.initials}
                  </div>
                  <div className="flex text-yellow-400" data-id="element-153">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-154" />)}
                  </div>
                </div>
                <div data-id="element-155">
                  <h4 className="text-xl font-bold text-brand-dark mb-1" data-id="element-156">
                    {t.name}
                  </h4>
                  <p className="text-sm text-gray-500 font-medium mb-4" data-id="element-157">
                    {t.role}
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed italic" data-id="element-158">
                    "{t.quote}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}